import { ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import { useStructure } from './useStructure';

const API_MONITORING_STRUCT = 'kron.tm3.service-web-1.0/webresources/restservice/monitoring/';

export function useMonitoringStructure() {
  const store = useStore();

  const {
    password,
    info,
    monitoringStruct,
    monitoringUpdate,
    server,
    prepareEvent,
    setMonitoringStruct,
    addScriptLog,
    setStruct,
    clearFacilityData
  } = useStructure();

  const intervalLoadMonitoringStruct = ref(null);

  const getValues = () => {
    const headers = {
      Authorization: 'Basic ' + btoa(info.value.login + ':' + password.value),
      'Content-Type': 'application/zip',
    };
    const apiStruct = `${server.value('TM_MIDDLE')}${API_MONITORING_STRUCT}`;

    axios
      .get(apiStruct, { headers })
      .then((response) => {
        setMonitoringStruct(prepareMonitoringStruct([...response.data]));
        checkSpeech();
      })
      .catch((er) => {
        setMonitoringStruct(prepareMonitoringStruct([]));
        addScriptLog({
          message: `Ошибка получение мониторинга Structure: ${er.response || er}`,
          facilityId: 0,
        });
      });
  };

  const checkSpeech = () => {
    if (!store.getters.enableEventSound) return;
    if (store.getters.enableEventFacilitySound) {
      prepareSpeechFacility();
    } else {
      prepareSpeech();
    }
  };

  const prepareSpeech = () => {
    const monitoring = monitoringStruct.value;
    let message = '';
    let count = 0;
    const eventTypes = {};

    for (let i = 0; i < monitoring.length; i++) {
      if (!monitoring[i]?.eventList?.length) continue;
      for (let y = 0; y < monitoring[i].eventList.length; y++) {
        const ev = monitoring[i].eventList[y];
        if (ev?.soundInfo?.shouldPlaySound && !eventTypes[ev.eventType.name]) {
          message += `${ev.eventType.name}. `;
          eventTypes[ev.eventType.name] = true;
          count++;
        }
        if (count > 4) break;
      }
      if (count > 4) break;
    }

    if (message.length) onSpeech(message);
  };

  const prepareSpeechFacility = () => {
    const monitoring = monitoringStruct.value;
    let message = '';
    let count = 0;

    for (let i = 0; i < monitoring.length; i++) {
      if (!monitoring[i]?.eventList?.length) continue;
      for (let y = 0; y < monitoring[i].eventList.length; y++) {
        const ev = monitoring[i].eventList[y];
        if (ev?.soundInfo?.shouldPlaySound) {
          if (ev?.soundInfo?.textForSoundReproduction) {
            message += `${ev.soundInfo.textForSoundReproduction}. `;
          } else {
            const facilityName = monitoring[i].facilityMonitoringName.replace(/(скв\.?|Скв\.?)/g, 'Скважина ');
            message += `${facilityName} ${ev.eventType.name}. `;
          }
          count++;
        }
        if (count > 3) break;
      }
      if (count > 3) break;
    }

    if (message.length) onSpeech(message);
  };

  const onSpeech = (message) => {
    console.log(message);
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance();
    utterance.text = message;
    utterance.lang = 'ru-RU';
    utterance.rate = store.getters.speechRate;
    utterance.pitch = store.getters.speechPitch;
    synth.speak(utterance);
  };

  const prepareMonitoringStruct = (data) => {
    return data.map((item) => ({
      ...item,
      facilityId: item.facilityMonitoringId,
      activeEvent: item.eventList?.length ? prepareEvent(item.eventList[0]) : '',
      activeEventsHint: item.eventList?.length
        ? item.eventList.map((e) => prepareEvent(e)).join('\n')
        : '',
      groupId: item.eventList?.length ? item.eventList[0].eventType?.groupId : null,
    }));
  };


  onMounted(() => {
    intervalLoadMonitoringStruct.value = setInterval(() => {
      getValues();
    }, monitoringUpdate.value * 1000);
    getValues();
  });

  onUnmounted(() => {
    clearInterval(intervalLoadMonitoringStruct.value);
  });

  return {

    password,
    info,
    monitoringStruct,
    monitoringUpdate,
    server,

    setStruct,
    clearFacilityData,

    getValues,
    checkSpeech,
    prepareSpeech,
    prepareSpeechFacility,
    onSpeech,
    prepareMonitoringStruct,
  };
}